module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dBgpx7/tc-custom/9781571208804.jpg?1704299963730",
      "alt": "This image is the cover for the book 250 Continuous-Line Quilting Designs"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("250 Continuous-Line Quilting Designs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Discover how to add beauty, texture, and special meaning to your quilt projects with this wonderful collection of continuous-line quilting designs.")]), _c('br'), _c('br'), _vm._v(" Laura is back with another collection of brand new continuous-line quilting designs that are sure to please! These creative, continuous-line designs are perfect for all machines-domestic, mid-arm, and longarm. Mix and match Laura Lee Fritz’s unique images to personalize your quilts. People, animals, nature, sports, and more. There is something here for everyone. A variety of design motifs can be grouped to tell a story, which will give you plenty of ideas for adding special meaning to every quilt you make. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Lee Fritz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Laura Lee Fritz Bio:  Laura Lee Fritz is renowned for her fanciful whole-cloth quilting and has added the finishing touch of fabulous machine quilting for many top quilt artists.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0